import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import Cookies from 'js-cookie';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { user } = useContext(UserContext);

  const isLoggedIn = !!user|| !!Cookies.get('accessToken'); // optional fallback

  if (!isLoggedIn) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  return children;
};

export default PrivateRoute;
